import { Text, VStack, Image, Spacer, Flex } from '@chakra-ui/react';
import moment from 'moment-timezone';

import logoBlack from '../../Assets/Logos/LOGO-ENTEL-NEGATIVO.webp';

const Footer = () => {
    return (
        <Flex bg="#F7F7F7" px="10" mt='4' mb={['275px','275px','170px','170px','170px']}>
            <Image src={logoBlack} alt="logo entel" style={{width: '35px'}} my="auto" h='auto' />
            <Spacer />
            <VStack
                spacing={0}
                align='stretch'
                p="2"
            >
                <Text fontSize="sm" color="black" className="General" textAlign="center">
                    Copyright &copy; {moment().format('YYYY')} - Be Call Group
                </Text>
                <Text fontSize="xs" color="black" className="General" textAlign="center">
                    Todos los derechos reservados
                </Text>
            </VStack>
        </Flex>
    )
}

export default Footer